import ProductSection from "../Components/productsection";
import { Helmet } from "react-helmet"
import koetjesweide from "../images/koetjesweide.jpg";

const HomeScreen = () => {
    return (
        <>
        <Helmet>
                <title>Over Ons | Hoeveslagerij De Spycker</title>
                <meta name="description" content="Leer meer over onze hoeveslagerij, onze geschiedenis en ambachtelijke vleesproductie."/>
                <link rel="canonical" href="https://www.hoeveslagerijdespycker.be/over-ons" />
        </Helmet>

        <div className="flex flex-col items-center space-y-12 px-4 sm:px-6">
            
            {/* Product Section */}
            <section className="flex flex-col md:flex-row items-center justify-center w-full max-w-8xl gap-12 py-12">
                <div className="md:w-1/2 flex justify-center">
                    <ProductSection 
                        image={koetjesweide}
                        className="rounded-xl shadow-lg transform transition-all duration-300 hover:scale-105"
                    />
                </div>
                <div className="md:w-1/2 text-center sm:text-left px-4">
                    <h2 className="text-3xl sm:text-4xl font-bold text-red-900 mb-4">Kwaliteitsvlees van eigen kweek</h2>
                    <p className="text-base sm:text-lg text-gray-800 leading-relaxed">
                        Op een boogscheut van Brugge en Damme biedt Hoeveslagerij De Spycker u kwaliteitsvol Maine-Anjou rundsvlees van eigen kweek. 
                        Rustiek genot op uw bord, gekweekt met de grootste zorg. Wij bieden u tevens varken en andere vleesbereidingen aan. 
                        Breng gerust een bezoek aan onze hoeveslagerij op de boerderij zelf of plaats uw bestelling telefonisch, via mail of online.
                    </p>
                </div>
            </section>

            {/* Video Section */}
            <section className="px-4 sm:px-6 py-12 text-center bg-gray-100 w-full flex flex-col items-center">
                <h2 className="text-3xl sm:text-4xl font-semibold text-red-900 mb-4">Bekijk onze video</h2>
                <div className="relative w-full max-w-6xl" style={{ paddingBottom: '56.25%' }}>
                    <iframe
                        title="De Spycker"
                        src="https://player.vimeo.com/video/129150096?h=a77db1e0e7"
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                        className="absolute top-0 left-0 w-full h-full rounded-lg shadow-lg"
                    ></iframe>
                </div>
            </section>
        </div>
        </>
    );
};

export default HomeScreen;